import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Addons = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.38717 1.4217C7.76769 1.20766 8.23231 1.20766 8.61283 1.4217L11.1128 2.82795C11.5064 3.04935 11.75 3.46583 11.75 3.91742V6.56136L14.1128 7.89045C14.5064 8.11185 14.75 8.52833 14.75 8.97992V11.7701C14.75 12.2217 14.5064 12.6381 14.1128 12.8595L11.6128 14.2658C11.2323 14.4798 10.7677 14.4798 10.3872 14.2658L8 12.923L5.61283 14.2658C5.23231 14.4798 4.76769 14.4798 4.38717 14.2658L1.88717 12.8595C1.49358 12.6381 1.25 12.2217 1.25 11.7701V8.97992C1.25 8.52833 1.49358 8.11185 1.88717 7.89045L4.25 6.56136V3.91742C4.25 3.46583 4.49358 3.04935 4.88717 2.82795L7.38717 1.4217ZM5.75 6.56136L8 7.82698L10.25 6.56136V4.06363L8 2.79801L5.75 4.06363V6.56136ZM8.75 9.12613V11.6239L11 12.8895L13.25 11.6239V9.12613L11 7.86051L8.75 9.12613ZM5 7.86051L2.75 9.12613V11.6239L5 12.8895L7.25 11.6239V9.12613L5 7.86051Z"
      fill="currentColor"
    />
  </Icon>
));

export default Addons;
